import lodash from "lodash";
import store from "../../../../../../store";

import { createPage } from "../../../../../../utils/page";
import { createLoading } from "../../../../../../utils/loading";
import { createColumns } from "./sampling-analysis-product-info.section";

export const { isLoading, setIsLoading } = createLoading();

export const actionPrefix = "resource/v1/transaction/samplingAnalysisProduct";

export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });

export const initData = ({ props, data }) => {
    const { itemsKey } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const items = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    data.columns = createColumns({ props, data });
    data.page = createPage({ data: items });
    data.tableOptions = { search: { activeKey: null } };
    data.manages = [];
    data.manageExtras = [];
    data.rowActions = [];
    fetchData({ props, data }).then(page => items.push(...page.data));
}

export const fetchData = ({ props }) => {
    const { fetchCriteria } = props;
    if (!fetchCriteria || fetchCriteria.fetched) {
        return Promise.resolve({ data: [] });
    }
    fetchCriteria.fetched = true;
    setIsLoading(true);
    return callSearch({ criteria: fetchCriteria }).finally(() => setIsLoading(false));
};